/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/stubFalse.js
 ** module id = ./node_modules/lodash/stubFalse.js
 ** module chunks = 0
 **/